export default __webpack_public_path__ + "static/media/logo4.148d47aa.png";